// T043: Create login page component

import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAuthStore } from '@/stores/authStore'
import { LoginForm } from '@/components/auth/LoginForm'

export default function AuthPage() {
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, navigate])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tight">Fast Steemit</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            A modern interface for the Steemit blockchain
          </p>
        </div>

        <div className="rounded-lg border bg-card p-8 shadow-sm">
          <h2 className="mb-6 text-2xl font-semibold">Sign in</h2>
          <LoginForm />
        </div>

        <p className="text-center text-xs text-muted-foreground">
          Your private keys are stored securely in your browser and never sent to any server.
        </p>
      </div>
    </div>
  )
}
